import React, { useContext, useCallback } from 'react'
import Font from '@cred/react-font'
import PropTypes from 'prop-types'
import WidgetContext from 'components/widget-context'
import { fireGtmEvent } from 'utils/gtm'
import { onlyMobile, exceptMobile } from 'common/visibility'
import FilterForm from '../shared/filter-form'
import styles from './styles.module.scss'

const CardsFilter = ({ form }) => {
  const widgetContext = useContext(WidgetContext),
    onChangeCategory = useCallback((e, value) => {
      const gtmValue = { category: value }

      fireGtmEvent('fieldChange', {
        ...gtmValue,
        ...widgetContext,
      })
    }, [widgetContext])

  return (
    <div className={styles.filter}>
      <div className={styles.column}>
        <Font type="disclaimer" color="lighter" className="mb-8">
        Partner Offers. Terms Apply.
        </Font>
        <Font type="medium" weight="bold" color="neutral" className={onlyMobile}>Find the right credit card</Font>
        <Font type="medium" weight="bold" color="neutral" className={exceptMobile}>Find the right credit card for you</Font>
      </div>
      <div className={styles.column}>
        <FilterForm
          form={form}
          onChangeCategory={onChangeCategory}
        />
      </div>
    </div>
  )
}

CardsFilter.propTypes = {
  form: PropTypes.string,
}

export { CardsFilter }

export default CardsFilter
